import { Badge, Popover } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserUpdates } from "~context/UserUpdatesContext/UserUpdatesContext";
import { useGetLocationParams } from "~hooks/useGetLocationParams.ts";
import { useNotificationService } from "~pages/Notifications/hooks/useNotificationService.ts";
import type { Notification } from "~types/notification";
import NotificationsPopoverContent from "./NotificationsPopoverContent";

const NotificationsPopover = () => {
  const { unreadNotificationCount, latestNotifications, refetch: refetchUserUpdates } = useUserUpdates();
  const { markNotificationAsRead } = useNotificationService();
  const { customerId } = useGetLocationParams();
  const navigate = useNavigate();
  const [popoverOpen, setPopoverOpen] = useState(false);

  const notificationsUrl = customerId ? `/${customerId}/notifications` : "";

  const handlePopoverClose = () => setPopoverOpen(false);

  const handleNotificationClick = (notification: Notification) => {
    handlePopoverClose();
    if (notification.unread) {
      void markNotificationAsRead(notification.key);
      refetchUserUpdates();
    }
    if (notificationsUrl) {
      navigate(notificationsUrl, { state: { from: location.pathname } });
    }
  };

  return (
    <div className="notifications-info">
      {customerId && (
        <Popover
          content={
            <NotificationsPopoverContent
              notifications={latestNotifications}
              unreadCount={unreadNotificationCount}
              notificationsUrl={notificationsUrl}
              onClose={handlePopoverClose}
              onNotificationClick={handleNotificationClick}
            />
          }
          trigger="click"
          open={popoverOpen}
          onOpenChange={setPopoverOpen}
          placement="bottomRight"
          arrow={false}
          styles={{ body: { padding: 0 } }}
        >
          <Badge count={unreadNotificationCount} offset={[-10, 10]} color="#FF0000">
            <div className="icon-circle">
              <i className="fa-solid fa-bell fa-lg bell-icon" />
            </div>
          </Badge>
        </Popover>
      )}
      {!customerId && (
        <div className="icon-circle icon-circle-blocked">
          <i className="fa-solid fa-bell fa-lg bell-icon-blocked" />
        </div>
      )}
    </div>
  );
};

export default NotificationsPopover;
